import { BookOpenIcon, CameraIcon } from '@heroicons/react/24/outline';
import arrowImage from '../../../assets/images/arrow_vector.png';
import bookDemo from '../../../assets/images/book_demo.jpg';
import bookDetails from '../../../assets/images/book_details.png';
import chatDemo from '../../../assets/images/chat_demo.png';
import { AiProcessing } from '../../books/components/AddBookForm';

import { useState } from 'react';
import { Button } from '../../../components/Button';
import { useNavigate, Link } from 'react-router-dom';

export const Landing = () => {
  const navigate = useNavigate();
  const [images, setImages] = useState<{ cover: File | null; back: File | null }>({
    cover: null,
    back: null
  });

  const handleImageChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    type: 'back' | 'cover'
  ) => {
    const file = event.target.files?.[0];
    if (file) {
      setImages((prev) => ({ ...prev, [type]: file }));
    }
  };
  return (
    <div>
      <section className="h-screen flex items-center justify-center relative bg-[url('assets/images/patterns/7863053.jpg')] bg-contain bg-repeat">
        <div className="flex flex-col lg:flex-row items-center gap-8 max-w-screen-xl mx-auto p-4 text-center lg:text-left">
          <h1 className="text-5xl lg:text-7xl text-gray-800 font-extrabold drop-shadow-2xl drop-shadow-2xl leading-normal lg:leading-relaxed">
            Sell your Books with{' '}
            <span className="text-cyan-900 bg-white/50 p-2 px-4 rounded-lg border-4 border-cyan-800 drop-shadow-xl">
              AI Magic
            </span>
          </h1>
          <div className="flex flex-col gap-8 shadow-2xl p-6 rounded-xl bg-white/80 shadow-cyan-800">
            <div className=" flex items-center gap-8 ">
              <div className="flex flex-col gap-2 items-center lg:items-start">
                <CameraIcon className="size-8" />
                <p className="font-bold">Take a photo</p>
                <p className="">Snap a quick picture of your book cover</p>
              </div>
              <div className="flex flex-col gap-2 items-center lg:items-start">
                <BookOpenIcon className="size-8" />
                <p className="font-bold">AI does the rest</p>
                <p className="">We'll generate all the book details automatically</p>
              </div>
            </div>
            <Link
              to="/login"
              className="text-center text-2xl font-bold drop-shadow-2xl text-white bg-cyan-800 py-3 px-4 rounded-lg hover:scale-105 transition duration-500">
              Start now
            </Link>
          </div>
        </div>
      </section>
      <section className="py-24 px-4  text-black bg-white w-full overflow-x-hidden">
        <div className="flex flex-col items-center gap-12 lg:gap-24 mb-12">
          <div className="flex items-center justify-center gap-3">
            <SectionTitle title="From picture to details in seconds" />
          </div>
          <div className="flex flex-col lg:flex-row items-center gap-16 justify-center">
            <div className="flex flex-col gap-3 items-center lg:-rotate-12">
              <h2 className="text-3xl font-bold">Picture</h2>
              <img src={bookDemo} alt="Book" className="w-[20rem] rounded-xl" />
            </div>
            <div className="flex flex-col gap-3 items-center mb-0 lg:mb-28 ">
              <h2 className="text-4xl md:text-5xl font-bold">To</h2>
              <img
                src={arrowImage}
                alt="Arrow"
                className="w-[15rem] -scale-y-100 -rotate-12 rotate-[45deg] lg:rotate-0"
              />
            </div>

            <div className="flex flex-col gap-3 items-center lg:rotate-12 mt-0 lg:mt-28">
              <h2 className="text-3xl font-bold">Details</h2>
              <img src={bookDetails} alt="Book Details" className="w-[30rem] rounded-xl" />
            </div>
          </div>
        </div>
      </section>

      <section className="py-32 px-4  text-black w-full">
        <div className="flex flex-col items-center gap-8 max-w-[50rem] mx-auto h—[25rem]">
          <SectionTitle title="Give it a try..." />
          <div className="w-full flex flex-col gap-3 ">
            <AiProcessing
              handleImageChange={handleImageChange}
              cover={images.cover}
              back={images.back}
            />
            <Button onClick={() => navigate('/login')}>Process with AI</Button>
          </div>
        </div>
      </section>
      <section className="py-24 px-4  text-black w-full bg-white">
        <div className="flex flex-col items-center gap-8 max-w-screen-xl mx-auto">
          <SectionTitle title="Connect with like-minded readers" />
          <div className="w-full flex flex-col gap-3">
            <img src={chatDemo} alt="Chat Demo" className="w-full rounded-xl" />
          </div>
        </div>
      </section>
    </div>
  );
};

const SectionTitle = ({ title }: { title: string }) => (
  <h1 className="text-3xl md:text-5xl text-center font-extrabold text-cyan-800">{title}</h1>
);
